import React, { Component } from "react";
import {
  Modal,
  Form,
  Button,
  Icon,
  List,
  Header,
  Segment,
  Select
} from "semantic-ui-react";
import Authorize from "./Authorize";
import {
  sendInvoice,
  getInvoice,
  getCustomerInvoiceInfo
} from "../lib/apiCalls";
import { toast } from "react-toastify";
import Money from "./Money";
import _ from "lodash";
import { moneyFormat } from "../lib/format";
import Validation from "./Validation";

class InvoiceModal extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      invoice: null,
      emailAddress: "",
      customerBalance: 0,
      emailAddresses: [],
      loading: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (!this.props.customerId) return;
    getCustomerInvoiceInfo(
      { customerId: this.props.customerId },
      (error, response) => {
        if (error) {
          toast.error(
            "Failed to retrieve customer's balance and email addresses"
          );
          return;
        }
        if (this._isMounted) {
          let defaultEmail = _.find(response.emailAddresses, {
            isPrimary: true
          });
          this.setState({
            customerBalance: response.balance,
            emailAddresses: response.emailAddresses,
            emailAddress: defaultEmail ? defaultEmail.emailAddress : ""
          });
          this.getInvoice();
        }
      }
    );
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  handleDateChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };
  handleAddition = (e, { value }) => {
    this.setState(prevState => ({
      emailAddresses: [
        { emailAddress: value, key: value },
        ...prevState.emailAddresses
      ]
    }));
  };
  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };
  getInvoice = _.debounce(() => {
    if (!this.props.appointmentId) {
      toast.warn(
        "Attempted to retrieve invoice but no appointment ID was given"
      );
      return;
    }
    this.setState({ loading: true });
    getInvoice(
      {
        appointmentId: this.props.appointmentId,
        customerId: this.props.customerId
      },
      (error, response) => {
        if (error) {
          toast.error("Failed to retrieve the invoice");
          this.setState({ loading: false });
          return;
        }
        if (this._isMounted) {
          this.setState({ invoice: response, loading: false });
        }
      }
    );
  }, 400);
  handleSend = () => {
    let { emailAddress } = this.state;
    if (!emailAddress || emailAddress === "") {
      toast.info("An email address is required to send an invoice");
      return;
    }
    let emailRegEx = /^(([^<>()[\].,;:\s@"]+(.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    if (!emailRegEx.test(emailAddress)) {
      toast.info("Please enter a valid email. Example: john.doe@example.com");
      return;
    }
    sendInvoice(
      {
        appointmentId: this.props.appointmentId,
        emailAddress: emailAddress,
        customerId: this.props.customerId
      },
      (error, response) => {
        if (error) {
          toast.error("Failed to send the invoice");
          return;
        }
        if (this._isMounted) {
          this.props.onClose();
          this.setState({
            emailAddress: ""
          });
        }
        toast.success("Successfully sent invoice to customer");
      }
    );
  };
  cancel = () => {
    this.setState({
      emailAddress: ""
    });
    this.props.onClose();
  };
  render() {
    let { customerBalance, emailAddress, invoice, loading } = this.state;
    let { open, userName } = this.props;

    let totalServices = 0;
    let totalPayment = 0;
    let creditUsed = 0;
    if (invoice) {
      totalServices = (
        parseFloat(invoice.serviceFeeGroom || 0) +
        parseFloat(invoice.serviceFeeTrip || 0) +
        parseFloat(invoice.serviceFeeGenerator || 0) +
        parseFloat(invoice.serviceFeeFuel || 0) -
        parseFloat(invoice.serviceDiscountTotal || 0) +
        parseFloat(invoice.serviceFeeOther || 0) +
        parseFloat(invoice.serviceFeeSalesTax || 0)
      ).toFixed(2);
      totalPayment = (
        parseFloat(invoice.cashAmount || 0) +
        parseFloat(invoice.creditCardAmount || 0) +
        parseFloat(invoice.giftCardAmount || 0) +
        parseFloat(invoice.checkAmount || 0)
      ).toFixed(2);
      // Check if credit was given and if there was still money owed to use credit
      if (
        parseFloat(invoice.creditAmount || 0) > 0 &&
        parseFloat(totalServices) + parseFloat(invoice.gratuity || 0) >
          parseFloat(totalPayment)
      ) {
        // Get the max amount of credit to be used and apply towards the total payment
        let leftToPay = (
          parseFloat(totalServices) +
          parseFloat(invoice.gratuity || 0) -
          parseFloat(totalPayment)
        ).toFixed(2);
        if (parseFloat(invoice.creditAmount || 0) > parseFloat(leftToPay)) {
          // Set credit used to left to pay when there is enough credit
          creditUsed = parseFloat(leftToPay);
        } else {
          // Set credit used to
          creditUsed = parseFloat(invoice.creditAmount || 0);
        }
      }
    }

    let totalDue = (
      parseFloat(totalServices) +
      parseFloat(invoice ? invoice.gratuity || 0 : 0) -
      parseFloat(totalPayment) -
      parseFloat(invoice ? invoice.creditAmount || 0 : 0)
    ).toFixed(2);

    let emailAddressOptions = _.uniqBy(
      this.state.emailAddresses,
      "emailAddress"
    ).map(email => ({
      key: email.emailAddress,
      text: email.emailAddress,
      value: email.emailAddress
    }));
    // Add the email address value to the dropdown if not included
    if (emailAddress !== "") {
      let selectedEmail = _.find(emailAddressOptions, { value: emailAddress });
      if (!selectedEmail) {
        emailAddressOptions.push({
          key: emailAddress,
          text: emailAddress,
          value: emailAddress
        });
      }
    }

    return (
      <div>
        <Modal
          closeOnDimmerClick={false}
          open={open}
          onClose={this.props.onClose}
        >
          <Modal.Header style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>Send Invoice</div>
            <div style={{ textAlign: "right", width: "50%" }}>
              Current Customer Balance:{" "}
              <span
                style={{
                  color: parseFloat(customerBalance) < 0 ? "red" : "green"
                }}
              >
                <Money value={customerBalance} />
              </span>
            </div>
          </Modal.Header>
          <Modal.Content
            style={{ borderBottom: "1px solid rgba(34,36,38,.15)" }}
          >
            <Form>
              <Form.Group>
                <Validation
                  validation={emailAddress ? "email" : null}
                  value={emailAddress || ""}
                  required
                >
                  {error => {
                    return (
                      <Form.Field error={error} required>
                        <label>Email</label>
                        <Select
                          search
                          clearable
                          required
                          error={error}
                          allowAdditions
                          name="emailAddress"
                          value={emailAddress}
                          onChange={this.handleChange}
                          options={emailAddressOptions}
                          onAddItem={this.handleChange}
                          placeholder="Choose Email"
                          noResultsMessage="Type to add new"
                        />
                      </Form.Field>
                    );
                  }}
                </Validation>
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Content scrolling>
            {invoice ? (
              <Segment loading={loading} placeholder={loading}>
                <Header style={{ display: "flex" }}>
                  <div style={{ width: "50%" }}>
                    Invoice {userName ? " for " + userName : ""}
                  </div>
                  <div style={{ textAlign: "right", width: "50%" }}>
                    {parseFloat(totalDue) < 0 ? "Credit Gained" : "Due"} $
                    {parseFloat(Math.abs(moneyFormat(totalDue))).toFixed(2)}
                  </div>
                </Header>

                <Header content="Services" block attached="top" />
                <Segment attached="bottom">
                  <List divided verticalAlign="middle">
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.serviceFeeGroom} />
                      </List.Content>
                      <List.Content>
                        Service Fee
                        {invoice.petNames ? (
                          <div>{`(${invoice.petNames})`}</div>
                        ) : (
                          ""
                        )}
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.serviceFeeTrip} />
                      </List.Content>
                      <List.Content>Trip Fee</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.serviceFeeGenerator} />
                      </List.Content>
                      <List.Content>Generator Fee</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.serviceFeeFuel} />
                      </List.Content>
                      <List.Content>Fuel Fee</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.serviceDiscountTotal} />
                      </List.Content>
                      <List.Content>Discounts</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.serviceFeeOther} />
                      </List.Content>
                      <List.Content>Other</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.serviceFeeSalesTax} />
                      </List.Content>
                      <List.Content>Tax</List.Content>
                    </List.Item>
                    <List.Item>
                      <strong>
                        <List.Content floated="right">
                          <Money value={invoice.serviceFee} />
                        </List.Content>
                        <List.Content>Services Total</List.Content>
                      </strong>
                    </List.Item>
                    <List.Item>
                      <strong>
                        <List.Content floated="right">
                          <Money value={invoice.gratuity} />
                        </List.Content>
                        <List.Content>Gratuity</List.Content>
                      </strong>
                    </List.Item>
                  </List>
                </Segment>

                <Header content="Credit Given" block attached="top" />
                <Segment attached="bottom">
                  <List divided verticalAlign="middle">
                    <List.Item>
                      <strong>
                        <List.Content floated="right">
                          <Money value={invoice.creditAmount} />
                        </List.Content>
                        <List.Content>Credited</List.Content>
                      </strong>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={creditUsed} />
                      </List.Content>
                      <List.Content>Used</List.Content>
                    </List.Item>
                  </List>
                </Segment>

                <Header content="Payments Received" block attached="top" />
                <Segment attached="bottom">
                  <List divided verticalAlign="middle">
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.cashAmount} />
                      </List.Content>
                      <List.Content>Cash</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.creditCardAmount} />
                      </List.Content>
                      <List.Content>Credit Card</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.checkAmount} />
                      </List.Content>
                      <List.Content>Check</List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content floated="right">
                        <Money value={invoice.giftCardAmount} />
                      </List.Content>
                      <List.Content>Gift Card</List.Content>
                    </List.Item>
                    <List.Item>
                      <strong>
                        <List.Content floated="right">
                          <Money value={totalPayment} />
                        </List.Content>
                        <List.Content>Payment Total</List.Content>
                      </strong>
                    </List.Item>
                  </List>
                </Segment>

                <Header content="Invoice Balance" block attached="top" />
                <Segment attached="bottom">
                  <List divided verticalAlign="middle">
                    <List.Item>
                      <strong>
                        <List.Content floated="right">
                          $
                          {parseFloat(Math.abs(moneyFormat(totalDue))).toFixed(
                            2
                          )}
                        </List.Content>
                        <List.Content>
                          {parseFloat(totalDue) < 0
                            ? "Credit Gained"
                            : "Amount Due"}
                        </List.Content>
                      </strong>
                    </List.Item>
                  </List>
                </Segment>
              </Segment>
            ) : (
              <Segment loading={loading} placeholder>
                <Header icon>
                  <Icon name="info" />
                  No Invoice Available
                </Header>
              </Segment>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button
              content="Send Invoice"
              color="green"
              onClick={this.handleSend}
            />
            <Button content="Cancel" onClick={this.cancel} />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default props => (
  <Authorize permission="SendInvoices">
    <InvoiceModal {...props} />
  </Authorize>
);
